import { inputValueToUnix } from './datetime';

const END_OF_DAY = 'T23:59:59';
const START_OF_DAY = 'T00:00';

/**
 * Value of `<input type="date">` -> unix seconds of the local start (default) or end of that day, '' when empty.
 * Legacy date pickers produced local midnight; `new Date('YYYY-MM-DD')` alone would parse as UTC.
 */
export const dateInputToUnix = (value: string, edge: 'start' | 'end' = 'start'): number | '' =>
  value ? inputValueToUnix(`${value}${edge === 'start' ? START_OF_DAY : END_OF_DAY}`) : '';
